<template>
  <filtertron-tray-section
    v-if="tab.type === 'Attachments' && tab.createdAt"
    id="tab-configurator-attachments"
    :title="lang.get('tabs.configuration.attachments.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div class="form-group">
        <label>{{ lang.get('setting.form.min_filesize.label') }}</label>
        <input
          type="text"
          :value="tab.minFilesize"
          class="form-control"
          @input="e => handleInput('minFilesize', toInt(e.target.value))"
        />
      </div>
      <div class="form-group">
        <label>{{ lang.get('setting.form.max_filesize.label') }}</label>
        <input
          type="text"
          :value="tab.maxFilesize"
          class="form-control"
          @input="e => handleInput('maxFilesize', toInt(e.target.value))"
        />
      </div>
      <div class="form-group">
        <label>{{ lang.get('setting.form.min_attachments.label') }}</label>
        <input
          type="text"
          :value="tab.minAttachments"
          class="form-control"
          @input="e => handleInput('minAttachments', toInt(e.target.value))"
        />
      </div>
      <div class="form-group">
        <label>{{ lang.get('setting.form.max_attachments.label') }}</label>
        <input
          type="text"
          :value="tab.maxAttachments"
          class="form-control"
          @input="e => handleInput('maxAttachments', toInt(e.target.value))"
        />
      </div>
      <div class="checkbox styled">
        <input
          id="accept-attachment-links"
          name="acceptAttachmentLinks"
          type="checkbox"
          :checked="tab.acceptAttachmentLinks"
          @change="e => handleInput('acceptAttachmentLinks', e.target.checked)"
        />
        <label for="accept-attachment-links">
          {{ lang.get('setting.form.accept_attachment_links.label') }}
        </label>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';
import toIntMixin from '../to-int-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection
  },
  mixins: [handleInputMixin, toIntMixin],
  props: {
    tab: {
      type: Object,
      required: true
    }
  }
};
</script>
